import { render, staticRenderFns } from "./VacationCreateDialog.vue?vue&type=template&id=b2bc3956"
import script from "./VacationCreateDialog.vue?vue&type=script&lang=js"
export * from "./VacationCreateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports